import { render, staticRenderFns } from "./music.vue?vue&type=template&id=6da4df00&scoped=true&"
import script from "./music.vue?vue&type=script&lang=ts&"
export * from "./music.vue?vue&type=script&lang=ts&"
import style0 from "./music.vue?vue&type=style&index=0&id=6da4df00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da4df00",
  null
  
)

export default component.exports